var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.218,
    height: 21,
    viewBox: "0 0 21.218 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M10,.625a8.125,8.125,0,0,0,7.036-4.062,8.125,8.125,0,0,0,0-8.125A8.125,8.125,0,0,0,10-15.625a8.125,8.125,0,0,0-7.036,4.063,8.125,8.125,0,0,0,0,8.125A8.125,8.125,0,0,0,10,.625ZM10-17.5a10,10,0,0,1,8.66,5,10,10,0,0,1,0,10A10,10,0,0,1,10,2.5a10,10,0,0,1-8.66-5,10,10,0,0,1,0-10A10,10,0,0,1,10-17.5Zm4.727,9.414L10.664-4.023a.934.934,0,0,1-1.324,0L5.273-8.086a.934.934,0,0,1,0-1.324.937.937,0,0,1,1.324,0l3.4,3.4,3.4-3.4a.934.934,0,0,1,1.324,0,.937.937,0,0,1,0,1.324Z",
    transform: "translate(0.609 18)",
    fill: "#228285",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.10329ce259f30a1fbf28d75bdfb0d6a1.svg";
export { ForwardRef as ReactComponent };